/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconFridge = createReactComponent("fridge", "IconFridge", [
  [
    "path",
    {
      d: "M5 3m0 2a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2z",
      key: "svg-0"
    }
  ],
  ["path", { d: "M5 10h14", key: "svg-1" }],
  ["path", { d: "M9 13v3", key: "svg-2" }],
  ["path", { d: "M9 6v1", key: "svg-3" }]
]);

export { IconFridge as default };
//# sourceMappingURL=IconFridge.js.map
